module.exports = __webpack_public_path__ + "static/media/030.236e71a8.jpg";